module.exports = __webpack_public_path__ + "static/sf_13.858e6986.png";